export default __webpack_public_path__ + "static/media/milho-white.38869eba.svg";